import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import styles from './Arrow.module.scss';

import { ReactComponent as ArrowIcon } from 'common/images/arrow_left.svg';

const PULL = {
  LEFT: 'left',
  RIGHT: 'right'
};

class Arrow extends PureComponent {
  static propTypes = {
    pull: PropTypes.oneOf([PULL.LEFT, PULL.RIGHT])
  };

  static defaultProps = {
    pull: PULL.LEFT
  };

  render() {
    const { pull } = this.props;
    const className = pull === PULL.LEFT ? styles.Left : styles.Right;

    return (
      <ArrowIcon
        className={`${styles.Arrow} ${className}`}
        onClick={this.props.onClick}
      />
    );
  }
}

export default Arrow;



// WEBPACK FOOTER //
// ./src/common/components/Carousel/components/Arrow/Arrow.js